module.exports = __webpack_public_path__ + "media/images/product_large_images/scan(600)-4b72dceb30939c1ac6eef003645c5512.png";